// Definición de colores oro viejo para usar en la aplicación
const goldColors = {
  main: '#B8860B',     // Oro viejo (Dark Goldenrod)
  light: '#D4AF37',    // Oro viejo más claro
  dark: '#856108',     // Oro viejo más oscuro
  pale: '#F5EFD4',     // Oro muy pálido para fondos sutiles
};

export default goldColors;
